import {
  isObjHasProperties,
  removeNonExistentPropertiesWithDiff,
} from '@/services/helpers/common'
import { useAuthStore } from '@/stores/authStore'
import { queryChecker } from '../common'

/**
 * Navigation guard that validates and cleans up query parameters
 * Ensures query params match expected schema and removes invalid params
 * @param {RouteLocationNormalized} to - Target route
 * @param {RouteLocationNormalized} from - Current route
 * @returns {NavigationGuardReturn} Navigation result or undefined to proceed
 */
export async function cleanupQueryParams(to, from) {
  const authStore = useAuthStore()
  const signedIn = await authStore.isUserSignedIn()

  if (!signedIn) {
    return undefined
  }

  const requireQueryCheck = to.matched.some(
    record => record.meta.requireQueryCheck,
  )

  if (!requireQueryCheck) {
    return undefined
  }

  const { defaultFilter } = to.meta
  const { filtered, removed } = removeNonExistentPropertiesWithDiff(
    to.query,
    defaultFilter,
  )

  // Add default filter if missing required properties
  if (!isObjHasProperties(filtered, defaultFilter)) {
    return {
      name: to.name,
      query: defaultFilter,
    }
  }

  // Remove invalid properties
  if (Object.keys(removed).length !== 0) {
    return {
      name: to.name,
      query: filtered,
    }
  }

  // Run custom query checker if defined
  const { checkerKey } = to.meta
  if (checkerKey && !queryChecker[checkerKey](to.query)) {
    return {
      name: to.name,
      query: defaultFilter,
    }
  }

  return undefined
}
